import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AgentChatComponent } from '../components/AgentChatComponent';
import { AgentAdminPage } from '../components/AgentChatComponent/AgentAdminPage';
import { STSAgentChatLayout } from '../components/STSLayout';

export interface AgentChatRouterProps {
  namespace?: string;
  backPath?: string;
  basePath?: string;
  defaultAgent?: string;
  showAgentsSidebar?: boolean;
  stsMode?: boolean;
  useSTSLayout?: boolean;
}

export const AgentChatRouter = ({ 
  namespace, 
  backPath, 
  basePath, 
  defaultAgent, 
  showAgentsSidebar, 
  stsMode,
  useSTSLayout
}: AgentChatRouterProps = {}) => {
  
  if (useSTSLayout && stsMode) {
    return (
      <Routes>
        <Route path="/admin" element={<AgentAdminPage namespace={namespace} backPath={backPath} />} />
        <Route path="/:agentApiName/:templateName" element={
          <STSAgentChatLayout
            namespace={namespace}
            backPath={backPath}
            basePath={basePath}
            defaultAgent={defaultAgent}
            showAgentsSidebar={showAgentsSidebar}
            stsMode={stsMode}
          />
        } />
        <Route path="/:agentApiName" element={
          <STSAgentChatLayout
            namespace={namespace}
            backPath={backPath}
            basePath={basePath}
            defaultAgent={defaultAgent}
            showAgentsSidebar={showAgentsSidebar}
            stsMode={stsMode}
          />
        } />
        <Route path="/" element={
          <STSAgentChatLayout
            namespace={namespace}
            backPath={backPath}
            basePath={basePath}
            defaultAgent={defaultAgent}
            showAgentsSidebar={showAgentsSidebar}
            stsMode={stsMode}
          />
        } />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/admin" element={<AgentAdminPage namespace={namespace} backPath={backPath} />} />
      <Route path="/:agentApiName/:templateName" element={<AgentChatComponent namespace={namespace} backPath={backPath} basePath={basePath} showAgentsSidebar={showAgentsSidebar} stsMode={stsMode} />} />
      <Route path="/:agentApiName" element={<AgentChatComponent namespace={namespace} backPath={backPath} basePath={basePath} showAgentsSidebar={showAgentsSidebar} stsMode={stsMode} />} />
      <Route path="/" element={<AgentChatComponent agent={defaultAgent} namespace={namespace} backPath={backPath} basePath={basePath} showAgentsSidebar={showAgentsSidebar} stsMode={stsMode} />} />
    </Routes>
  );
};
